import PropTypes from 'prop-types';
import { colors, screen } from 'components/styles/variables';
import Rating from 'components/Dealer/Rating';

const DealerTitle = ({ title, rating }) => {
  return (
    <div className="dealer-heading">
      <h1 className="dealer-title">{title}</h1>
      {rating && <Rating value={rating} />}
      <style jsx>{`
        .dealer-heading {
          display: flex;
          margin-bottom: 5px;
          width: 100%;
          justify-content: space-between;
        }

        .dealer-title {
          font-size: 20px;
          letter-spacing: 0.6px;
          color: ${colors.BLACK};
          margin-right: 15px;
          text-transform: uppercase;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .dealer-title {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

DealerTitle.propTypes = {
  title: PropTypes.string,
  rating: PropTypes.number,
};

export default DealerTitle;
